(function () {
    let tabs = document.querySelectorAll(".page-subnavigation__items .page-subnavigation__item");

    if (tabs) {
        tabs.forEach((tab) => {
            tab.addEventListener("click", function (e) {
                e.preventDefault();
                document.querySelectorAll('.page-subnavigation__item.active').forEach((x) => x.classList.remove('active'))
                document.querySelectorAll('.professional__tab-content--active').forEach((x) => x.classList.remove('professional__tab-content--active'))
                tab.classList.add('active');
                let contentElement = document.getElementById(e.target.dataset.tab)
                if (contentElement) {
                    contentElement.classList.add("professional__tab-content--active")
                    var offsetPosition = document.querySelector(".page-hero").clientHeight + 10;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            });
        })
    }

    let sectorToggle = document.querySelector(".professional-sectors__toggle");
    sectorToggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (document.querySelector('.search-results__section-body.active')) {
            sectorToggle.querySelector('i').setAttribute('class', 'icon-chevron-down')
            document.querySelector('.search-results__section-body.active').classList.remove('active');
        } else {
            sectorToggle.querySelector('i').setAttribute('class', 'icon-chevron-up')
            document.querySelector('.search-results__section-body').classList.add('active');
        }
    });

    let readMoreToggle = document.querySelector(".professional__read-more");
    if (readMoreToggle) {
        readMoreToggle.addEventListener("click", function (e) {
            e.preventDefault();
            if (document.querySelector('.professional__read-more-content--open')) {
                readMoreToggle.innerText = "Read More";
                document.querySelector('.professional__read-more-content').classList.remove('professional__read-more-content--open');
            } else {
                readMoreToggle.innerText = "Read Less";
                document.querySelector('.professional__read-more-content').classList.add('professional__read-more-content--open');
            }
        });
    }

    let overviewSection = document.querySelector(".professional-overview");
    if (overviewSection) {
        let firstParagraph = overviewSection.querySelector("p:first-child");
        if (firstParagraph) {
            var d = document.createElement('h3');
            d.innerHTML = firstParagraph.innerHTML;

            firstParagraph.parentNode.replaceChild(d, firstParagraph);
        }
    }
})();